import { useState, useEffect, forwardRef } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { useUtils } from '../../context/UtilsProvider';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 * Snack bar alert component
 * @returns 
 */
export default function SnackbarAlert() {

  // Alert state controlled in context
  const { alertMessage, alertSeverity, alertSeverityTypes, setAlertMessage, setAlertSeverity } = useUtils();
  
  // severity - error, warning, info, success
  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    setAlertMessage("");
    setAlertSeverity(alertSeverityTypes.info);
  };

  useEffect(() => {
    if (alertMessage) {
      setOpen(true);
    }
  }, [alertMessage]);

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={alertSeverity} sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Stack>
  );
}